import { ChipLink, cn } from '@ondit/ui'
import { PAGE_HEADER_BAR } from '@/components/page-header-bar'
import { useT } from '~/core/i18n'

interface IntegrationTabsHeaderProps {
  active: 'integrations' | 'search'
  workspaceId: string
}

/**
 * Top-of-page tab header shared by the Integrations and Search pages — two views
 * of one surface, so each highlights itself and links to its sibling.
 *
 * The `gap-1` is explicit because chips carry no outer margin — the parent owns the
 * space between them.
 */
export function IntegrationTabsHeader({ active, workspaceId }: IntegrationTabsHeaderProps) {
  const t = useT()

  return (
    <div className={cn(PAGE_HEADER_BAR, 'gap-1')}>
      <ChipLink href={`/w/${workspaceId}/settings/integrations`} active={active === 'integrations'}>
        {t('Integrations')}
      </ChipLink>
      <ChipLink href={`/w/${workspaceId}/agent/search`} active={active === 'search'}>
        {t('Search')}
      </ChipLink>
    </div>
  )
}
